export const iconFontAwesomeDesignWebAwesome = (
	<i className="fa-solid fa-web-awesome"></i>
);
